import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import { useSupportedLocale } from '@flipster/i18n/hooks';
import ChevronDownIcon from '@flipster/react/icon/generated/ChevronDownIcon';
import { css } from '@flipster/styled-system/css';
import { hstack } from '@flipster/styled-system/patterns';
import { token } from '@flipster/styled-system/tokens';

import { getLocalizedText } from '../section-list/utils';
import { rewardHubV2Bunja } from '../state';

const Rules = () => {
  const locale = useSupportedLocale();

  const { skinAtom } = useBunja(rewardHubV2Bunja);
  const packageRules = getLocalizedText(useAtomValue(skinAtom)?.description.tail?.localizationTable, locale);

  if (!packageRules) return null;

  return (
    <section className={css({ px: 16, my: 40, smallDesktop: { px: 0 } })}>
      <details
        className={css({
          p: 16,
          bgColor: 'background.default.level-1',
          rounded: 8,
          _open: {
            '& svg': { rotate: '180deg' },
          },
        })}
      >
        <summary
          className={hstack({
            gap: 4,
            justify: 'space-between',
            cursor: 'pointer',
          })}
        >
          <span className={css({ textStyle: 'Text/L/Strong', color: 'content.default.level-5' })}>Rules</span>{' '}
          <ChevronDownIcon size={16} color={token('colors.content.default.level-3')} />
        </summary>
        <div
          className={css({
            pt: 12,
            whiteSpace: 'pre-line',
            textStyle: 'Text/M/Regular',
            color: 'content.default.level-2',
          })}
        >
          {packageRules}
        </div>
      </details>
    </section>
  );
};

export default Rules;
